import React from 'react'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell, TableHead, TableRow } from '@material-ui/core'

export const CommissionsTableHead = () => {
  const classes = useStyles()

  return (
    <TableHead>
      <TableRow className={clsx('table_head_row', classes.head)} style={{}}>
        <TableCell className={classes.cell}>Название</TableCell>
        <TableCell className={classes.cell}>Сумма</TableCell>
        <TableCell className={classes.cell}>Тип</TableCell>
      </TableRow>
    </TableHead>
  )
}

const useStyles = makeStyles(
  ({palette}) => ({
    head:{
      background: palette.mpSkladSecondary.blue
    },
    cell: {
      border: `2px solid ${palette.mpSkladPrimary.white}`,
      padding: '8px 10px',
      fontSize: '12px',
      height: 30
    }
  }))